var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgCooktop = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 26.833,
  height: 23
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "Customer Supplied Professional Range"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Rectangle 279",
  fill: "#fffbfb",
  stroke: "#4e4e4e"
}, /*#__PURE__*/React.createElement("path", {
  d: "M26.833 0v19a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V0h26.833Z",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M26.333.5V19a3.5 3.5 0 0 1-3.5 3.5H4A3.5 3.5 0 0 1 .5 19V.5h25.833Z",
  fill: "none"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Ellipse 11",
  transform: "translate(16.093 7)",
  fill: "#fff",
  stroke: "#4e4e4e",
  strokeWidth: 0.5
}, /*#__PURE__*/React.createElement("circle", {
  cx: 2.5,
  cy: 2.5,
  r: 2.5,
  stroke: "none"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 2.5,
  cy: 2.5,
  r: 2.25,
  fill: "none"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "range"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Ellipse 11",
  transform: "translate(16.093 14)",
  fill: "#fff",
  stroke: "#4e4e4e",
  strokeWidth: 0.5
}, /*#__PURE__*/React.createElement("circle", {
  cx: 2.5,
  cy: 2.5,
  r: 2.5,
  stroke: "none"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 2.5,
  cy: 2.5,
  r: 2.25,
  fill: "none"
}))), /*#__PURE__*/React.createElement("g", {
  "data-name": "range"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Ellipse 11",
  transform: "translate(5.74 7)",
  fill: "#fff",
  stroke: "#4e4e4e",
  strokeWidth: 0.5
}, /*#__PURE__*/React.createElement("circle", {
  cx: 2.5,
  cy: 2.5,
  r: 2.5,
  stroke: "none"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 2.5,
  cy: 2.5,
  r: 2.25,
  fill: "none"
}))), /*#__PURE__*/React.createElement("g", {
  "data-name": "range"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Ellipse 11",
  transform: "translate(5.74 14)",
  fill: "#fff",
  stroke: "#4e4e4e",
  strokeWidth: 0.5
}, /*#__PURE__*/React.createElement("circle", {
  cx: 2.5,
  cy: 2.5,
  r: 2.5,
  stroke: "none"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 2.5,
  cy: 2.5,
  r: 2.25,
  fill: "none"
}))), /*#__PURE__*/React.createElement("g", {
  "data-name": "Rectangle 291",
  fill: "#4e4e4e",
  stroke: "#4e4e4e"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "none",
  d: "M26.833 0v5H0V0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M26.333.5v4H.5v-4z"
})))));
export default SvgCooktop;